var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
export var useApiQuery = function (queryConfig) {
    var endpointOptions = queryConfig.endpoint.getMeta();
    var queryOptions = queryConfig.options || {};
    var combinedQueryOptions = __assign(__assign({}, endpointOptions), queryOptions);
    var queryKey = queryConfig.endpoint.getKey(queryConfig.payload);
    return useQuery(queryKey, function (_a) {
        var signal = _a.signal;
        return queryConfig.endpoint.request(queryConfig.payload, signal);
    }, combinedQueryOptions);
};
